import {useSubheader} from '_metronic/layout'
import {_} from 'i18n'
import React from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'

import AccountInformation from './AccountInformation'
import ChangePassword from './ChangePassword'
import {ProfileCard} from './components/ProfileCard'
import EmailSettings from './EmailSettings'
import NotificationConfiguration from './NotificationConfiguration'
import PersonaInformation from './PersonaInformation'

export default function UserProfilePage() {
  const suhbeader = useSubheader()
  suhbeader.setTitle(_`Perfil do usuário`)

  return (
    <div className="d-flex flex-row">
      <ProfileCard></ProfileCard>
      <div className="flex-row-fluid ml-lg-8">
        <Switch>
          <Redirect from="/user-profile" exact={true} to="/user-profile/personal-information" />
          <Route path="/user-profile/account-information" component={AccountInformation} />
          <Route path="/user-profile/change-password" component={ChangePassword} />
          <Route path="/user-profile/email-settings" component={EmailSettings} />
          <Route path="/user-profile/personal-information" component={PersonaInformation} />
          <Route path="/user-profile/notification-configuration" component={NotificationConfiguration} />
        </Switch>
      </div>
    </div>
  )
}
